import useSWR from 'swr';
import api from './axios';

// SWR fetcher function
const fetcher = (url: string) => api.get(url).then(res => res.data);

export interface ConfigData {
  storeName: string;
  storeLogo: string;
  storeWalletLogo: string;
  whatsAppLink: string;
  whatsAppEnabled: boolean;
  businessName: string;
  businessPhone: string;
  businessAddress: string;
  businessEmail: string;
  storeAddressLine1: string;
  storeAddressLine2: string;
  storeCity: string;
  storeCountryState: string;
  storePostcode: string;
  enableGuestCheckout: boolean;
  currency: string;
  timezone: string;
}

// Fetch config data
export const fetchConfig = async (): Promise<ConfigData> => {
  const response = await api.get('/api/config');
  return response.data;
};

// Custom hook to get config data
export const useConfig = () => {
  const { data, error, isLoading } = useSWR<ConfigData>('/api/config', fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
    refreshInterval: 0, // Don't auto-refresh
  });

  return {
    config: data,
    error,
    isLoading,
  };
};
